<template>
  <div id="page-shops-list">

    <!-- BREADCRUMB SECTION -->
    <vs-row class="mb-5" vs-align="center">
      <vs-col vs-w="12">
        <h2 class="breadcrumb">Καταστήματα</h2>
      </vs-col>
    </vs-row>

    <!-- start::validation observer -->
    <validation-observer v-slot="{invalid}">

      <!-- start::form -->
      <form>
        <!--      <vs-button @click="popupActive=true; resetItem();" color="primary" type="border">Προσθήκη νέου καταστήματος</vs-button>-->

        <!-- start::pop up -->
        <vs-popup class="holamundo" title="Νέο κατάστημα"
                  :active.sync="popupActive">

          <!-- start::shop -->
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Κατάστημα*</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <validation-provider rules="required" v-slot="{errors}">
                <vs-input class="w-full" v-model="itemName"/>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <!-- end::shop -->

          <!-- start::team -->
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Ομάδα</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <v-select v-model="selectedGroup" :taggable="true"
                        :clearable="true" :options="groups" name="role"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            </div>
          </div>
          <!-- end::team -->

          <!-- start::status -->
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Ενεργό</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-switch v-model="itemStatus"/>
            </div>
          </div>
          <!-- end::status -->

          <!-- start::phone -->
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Τηλέφωνο</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <validation-provider rules="numeric" v-slot="{errors}">
                <vs-input class="w-full" v-model="phone"/>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <!-- end::phone -->

          <!-- start::mobile -->
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Κινητό</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <validation-provider rules="numeric" v-slot="{errors}">
                <vs-input class="w-full" v-model="mobile"/>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <!-- end::mobile -->

          <!-- start::address -->
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Διεύθυνση</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" v-model="address"/>
            </div>
          </div>
          <!-- end::address -->

          <!-- start::city -->
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Πόλη</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" v-model="city"/>
            </div>
          </div>
          <!-- end::city -->

          <!-- start::postcode -->
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Τ.Κ.</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <validation-provider rules="numeric" v-slot="{errors}">
                <vs-input class="w-full" v-model="postcode"/>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <!-- end::postcode -->

          <!-- start::region -->
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Περιοχή</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" v-model="region"/>
            </div>
          </div>
          <!-- end::region -->

          <!-- start::email -->
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Email</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <validation-provider rules="email" v-slot="{errors}">
                <vs-input class="w-full" v-model="email"/>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <!-- end::email -->

          <!-- start::submit form -->
          <div class="vx-row">
            <div class="vx-col w-full text-right">
              <vs-button :disabled="invalid" class="mb-2 text-right"
                         @click="addRecord">
                Αποθήκευση
              </vs-button>
            </div>
          </div>
          <!-- end::submit form -->

        </vs-popup>
        <!-- end::pop up -->

      </form>
      <!-- end::form -->

    </validation-observer>
    <!-- end::validation observer -->

    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center">

        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{
                  currentPage * paginationPageSize - (paginationPageSize - 1)
                }} - {{
                  recordsData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : recordsData.length
                }} of {{ recordsData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input
            class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
            v-model="searchQuery" @input="updateSearchQuery"
            placeholder="Αναζήτηση..."/>
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue ref="agGridTable" :components="components"
                   :gridOptions="gridOptions"
                   class="ag-theme-material w-100 my-4 ag-grid-table"
                   :columnDefs="columnDefs" :defaultColDef="defaultColDef"
                   :rowData="recordsData" rowSelection="multiple" colResizeDefault="shift"
                   :animateRows="true" :floatingFilter="true" :pagination="true"
                   :paginationPageSize="paginationPageSize" :suppressPaginationPanel="true"
                   :enableRtl="$vs.rtl" :paginationAutoPageSize="true" :filter="true"
                   @rowDoubleClicked="editItem"
                   :resizable="true">
      </ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage"/>
    </div>
  </div>

</template>

<script>
import {AgGridVue} from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

// Cell Renderer
import CellRendererLink from './cell-renderer-dealers/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer-dealers/CellRendererStatus.vue'
import CellRendererVerified from './cell-renderer-dealers/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer-dealers/CellRendererActions.vue'

// Validation
import {ValidationObserver, ValidationProvider, extend} from 'vee-validate'
import {required} from 'vee-validate/dist/rules'
import {email} from 'vee-validate/dist/rules'
import {numeric} from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: 'Υποχρεωτικό πεδίο',
})
extend('email', {
  ...email,
  message: 'Πεδίο Email',
})
extend('numeric', {
  ...numeric,
  message: 'Πεδίο με αριθμό',
})

export default {
  name: 'Shops',
  components: {
    AgGridVue,
    vSelect,
    flatPickr,
    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,

    // Validation components
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      initiated: false,
      modalTitle: '',
      popupActive: false,
      switch1: true,

      searchQuery: '',

      // AgGrid
      gridApi: null,
      gridOptions: {
        floatingFilter: true,
        filter: true,
        pagination: true,
        pivotPanelShow: 'always',
        colResizeDefault: 'shift',
        animateRows: true,
        resizable: true,
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'id',
          width: 125,
          filter: 'agTextColumnFilter',
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          suppressNavigable: true,
          cellClass: 'no-border',
        },
        {
          headerName: 'Όνομα',
          field: 'name',
          filter: 'agTextColumnFilter',
          flex: 2,
          suppressNavigable: true,
          cellClass: 'no-border',
        },
        {
          headerName: 'Ομάδα',
          field: 'group.name',
          filter: 'agTextColumnFilter',
          flex: 1,
          suppressNavigable: true,
          cellClass: 'no-border',
        },
        {
          headerName: 'Flagged',
          field: 'dealer_status',
          filter: 'agTextColumnFilter',
          width: 150,
          cellRendererFramework: 'CellRendererStatus',
          suppressNavigable: true,
          cellClass: 'no-border',
        },
        {
          headerName: '',
          field: 'transactions',
          width: 60,
          filter: false,
          cellRendererFramework: 'CellRendererActions',
          pinned: 'right',
          suppressNavigable: true,
          cellClass: 'no-border',
        },
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions,
      },
    }
  },
  watch: {
    roleFilter(obj) {
      this.setColumnFilter('role', obj.value)
    },
    statusFilter(obj) {
      this.setColumnFilter('status', obj.value)
    },
    isVerifiedFilter(obj) {
      const val =
          obj.value === 'all' ? 'all' : obj.value === 'yes' ? 'true' : 'false'
      this.setColumnFilter('is_verified', val)
    },
    departmentFilter(obj) {
      this.setColumnFilter('department', obj.value)
    },
  },
  computed: {
    recordsData() {
      return this.$store.getters.getDealers
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      },
    },
    message: {
      get() {
        return this.$store.state.obj.message
      },
      set(value) {
        this.$store.commit('updateMessage', value)
      },
    },
    groups() {
      return this.$store.getters.getGroups
    },
    selectedGroup: {
      get() {
        return this.$store.getters.getGroup
      },
      set(group) {
        this.$store.dispatch('setGroup', group)
      },
    },
    item() {
      return this.$store.getters.getDealer
    },
    itemName: {
      get() {
        return this.item.name
      },
      set(value) {
        this.$store.dispatch('setDealerName', value)
      },
    },
    itemStatus: {
      get() {
        return this.item.dealer_status
      },
      set(value) {
        this.$store.dispatch('setDealerStatus', value)
      },
    },
    phone: {
      get() {
        return this.item.phone
      },
      set(value) {
        this.$store.dispatch('setDealerPhone', value)
      },
    },
    mobile: {
      get() {
        return this.item.mobile
      },
      set(value) {
        this.$store.dispatch('setDealerMobile', value)
      },
    },
    address: {
      get() {
        return this.item.address
      },
      set(value) {
        this.$store.dispatch('setDealerAddress', value)
      },
    },
    city: {
      get() {
        return this.item.city
      },
      set(value) {
        this.$store.dispatch('setDealerCity', value)
      },
    },
    postcode: {
      get() {
        return this.item.postcode
      },
      set(value) {
        this.$store.dispatch('setDealerPostcode', value)
      },
    },
    region: {
      get() {
        return this.item.region
      },
      set(value) {
        this.$store.dispatch('setDealerRegion', value)
      },
    },
    email: {
      get() {
        return this.item.email
      },
      set(value) {
        this.$store.dispatch('setDealerEmail', value)
      },
    },
  },
  methods: {
    resetItem() {
      let vm = this
      vm.item = {}
      vm.modalTitle = 'Νέα Εγγραφή'
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = {type: 'equals', filter: val}
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter =
          this.statusFilter =
              this.isVerifiedFilter =
                  this.departmentFilter =
                      {
                        label: 'All',
                        value: 'all',
                      }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
    validateForm() {
      let vm = this
      if (!vm.item.name && vm.initiated) {
        return false
      }
      return true
    },
    addRecord() {
      let vm = this
      // VALIDATION SECTION
      this.initiated = true
      let groupId = null
      if(vm.selectedGroup && vm.selectedGroup.id){
        groupId = vm.selectedGroup.id
      }
      const payload = {
        dealerId: vm.item.id,
        name: vm.item.name,
        dealer_status: vm.item.dealer_status,
        phone: vm.item.phone,
        mobile: vm.item.mobile,
        address: vm.item.address,
        city: vm.item.city,
        postcode: vm.item.postcode,
        region: vm.item.region,
        email: vm.item.email,
        groupId: groupId,
      }
      if (vm.item.id) {
        this.$store
            .dispatch('updateDealer', payload)
            .then(() => {
              vm.$vs.notify({
                color: 'success',
                title: 'Επιτυχία',
                position: 'top-right',
                text: 'Οι αλλαγές σας αποθηκεύτηκαν.',
              })
              vm.popupActive = false
              this.$store.dispatch('setGroup', null)
              this.loadGroups()
              this.$store.dispatch('fetchDealers').catch((err) => {
                console.error(err)
              })
            })
            .catch((err) => {
              vm.$vs.notify({
                color: 'danger',
                title: 'Σφάλμα',
                position: 'top-right',
                text: 'Υπήρξε κάποιο πρόβλημα και τα δεδομένα δεν αποθηκεύτηκαν.',
              })
              console.error(err)
            })
      } else {
        this.$store
            .dispatch('addDealer', item)
            .then(() => {
              vm.$vs.notify({
                color: 'success',
                title: 'Επιτυχία',
                position: 'top-right',
                text: 'Οι αλλαγές σας αποθηκεύτηκαν.',
              })
              vm.popupActive = false
              vm.item = {}
              this.loadGroups()
              this.$store.dispatch('fetchDealers').catch((err) => {
                console.error(err)
              })
            })
            .catch((err) => {
              vm.$vs.notify({
                color: 'danger',
                title: 'Σφάλμα',
                position: 'top-right',
                text: 'Υπήρξε κάποιο πρόβλημα και τα δεδομένα δεν αποθηκεύτηκαν.',
              })
              console.error(err)
            })
      }
    },
    editRecord() {
      this.popupActive = true
      this.modalTitle = 'Επεξεργασία εγγραφής'
    },
    editItem(item) {
      this.$store.dispatch('setGroup', item.data.group)
      this.$store.dispatch('setDealer', item.data);
      // Fire event from parent.
      this.editRecord();
    },
    loadGroups() {
      this.$store.dispatch('fetchGroups')
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
          '.ag-header-container'
      )
      header.style.left = `-${String(
          Number(header.style.transform.slice(11, -3)) + 9
      )}px`
    }
  },
  created() {
    // Ομάδες.
    this.loadGroups()

    // Καταστήματα.
    this.$store.dispatch('fetchDealers')
  },
}
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>

